import checkAnySubtestCompletions from "../checkAnySubtestCompletions";
import checkForAnyCompleteSubtests from "../checkForAnyCompleteSubtests";

export default function findNoCompletionsAlertNeeded (
  role, 
  scoring, 
  notInitializing, 
  selectedStudent, 
  userAssessment,
  groupUA,
) {
  if ((role !== 'Student') && scoring && notInitializing) {
    if (role !== 'Student') {
      if (selectedStudent && userAssessment) {
        if (!checkForAnyCompleteSubtests(userAssessment)) {
          return 'Student'
        }
      } else if (groupUA) {
        if (!checkAnySubtestCompletions(groupUA)) {
          return 'Group'
        }
      } else {
        if (selectedStudent) {
          return 'Student'
        } else {
          return 'Group'
        }
      }
    } else if (groupUA) {
      if (!checkAnySubtestCompletions(groupUA)) {
        return 'Group'
      }
    } else {
      return 'Group'
    }
  } else if ((role !== 'Student') && notInitializing) {
    return 'Group'
  }
  return ''
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/findNoCompletionsAlertNeeded.js